export const iconFontAwesomeBuildingsLandmarkDome = (
	<i className="fa-solid fa-landmark-dome"></i>
);
